"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UsernameModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const react_hook_form_1 = require("react-hook-form");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const rootNavigation_1 = require("../../navigation/rootNavigation");
const useAnalytics_1 = __importDefault(require("../../hooks/useAnalytics"));
const useAppQuota_1 = require("../../hooks/useAppQuota");
const useAppMessage_1 = require("../../hooks/useAppMessage");
const store_1 = require("../../store");
const user_1 = require("../../store/selectors/user");
const appState_1 = require("../../store/selectors/appState");
const user_2 = require("../../slices/user");
const subscription_1 = require("../../slices/subscription");
const appState_2 = require("../../slices/appState");
const character_1 = require("../../slices/character");
const GradientButton_1 = require("../GradientButton");
const AppText_1 = require("../AppText");
const FormInput_1 = __importDefault(require("../FormInput"));
const character_2 = require("../../services/character");
const cache_1 = __importDefault(require("../../helper/cache"));
const colors_1 = require("../../common/colors");
const application_host_1 = require("../../common/application-host");
const useDevice_1 = require("../../hooks/useDevice");
const TYPE_TIMING = 500;
const SPINNER_TIME = 1500;
const FormInput = (FormInput_1.default);
function UsernameModal() {
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { control, handleSubmit, trigger: triggerValidation } = (0, react_hook_form_1.useForm)();
    const { trackUserSignUp } = (0, useAnalytics_1.default)();
    const { loadUserQuota } = (0, useAppQuota_1.useAppQuota)();
    const shouldInsertUsername = (0, react_redux_1.useSelector)(appState_1.selectShouldInsertUsername);
    const userId = (0, react_redux_1.useSelector)(user_1.selectUserId);
    const email = (0, react_redux_1.useSelector)(user_1.selectUserEmail);
    const [isUniqueUserName, setIsUniqueUserName] = (0, react_1.useState)(null);
    const [isCheckingUsername, setIsCheckingUsername] = (0, react_1.useState)(false);
    const [uniquenessCheckTimer, setUniquenessCheckTimer,] = (0, react_1.useState)();
    const [wasSavedAttempt, setWasSavedAttempt] = (0, react_1.useState)(false);
    const { showNotification } = (0, useAppMessage_1.useAppMessage)();
    const { current: spinningValue } = (0, react_1.useRef)(new react_native_1.Animated.Value(0));
    const { current: moveAnimation } = (0, react_1.useRef)(new react_native_1.Animated.Value(0));
    const { current: rotationDegree } = (0, react_1.useRef)(spinningValue.interpolate({
        inputRange: [0, 360],
        outputRange: ['0deg', '360deg'],
    }));
    const { current: spinningLoop } = (0, react_1.useRef)(react_native_1.Animated.loop(react_native_1.Animated.timing(spinningValue, {
        toValue: 360,
        duration: SPINNER_TIME,
        easing: react_native_1.Easing.linear,
        useNativeDriver: false,
    })));
    const isMacOSSafariWebView = /Macintosh.*AppleWebKit(?!.*Safari)/.test(navigator.userAgent);
    const handleInputFocus = () => {
        if (isMobileScreen && !isMacOSSafariWebView) {
            react_native_1.Animated.timing(moveAnimation, {
                toValue: -148,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    };
    const handleInputBlur = () => {
        if (isMobileScreen && !isMacOSSafariWebView) {
            react_native_1.Animated.timing(moveAnimation, {
                toValue: 0,
                duration: 300,
                useNativeDriver: true,
            }).start();
        }
    };
    (0, react_1.useEffect)(() => {
        if (isCheckingUsername) {
            spinningLoop.start();
        }
        else {
            spinningLoop.reset();
        }
    }, [isCheckingUsername]);
    (0, react_1.useEffect)(() => {
        console.log(wasSavedAttempt, isUniqueUserName);
        if (wasSavedAttempt) {
            triggerValidation();
        }
    }, [wasSavedAttempt, isUniqueUserName]);
    const handleUsernameChange = (0, react_1.useCallback)(({ target: { value } }) => {
        clearTimeout(uniquenessCheckTimer);
        if (!value) {
            setIsUniqueUserName(null);
            setIsCheckingUsername(false);
        }
        else {
            setIsCheckingUsername(true);
            setUniquenessCheckTimer(setTimeout(() => {
                (0, character_2.checkUsernameUniqueness)({ username: value }).then((result) => {
                    setIsUniqueUserName(result.success);
                    setIsCheckingUsername(false);
                });
            }, TYPE_TIMING));
        }
    }, [uniquenessCheckTimer]);
    const handleSaveUser = (0, react_1.useCallback)(async ({ Name, Username }) => {
        dispatch((0, character_1.createPermanentUserAsync)({
            id: userId,
            email: email,
            username: Username,
            name: Name,
        })).unwrap().then(async (result) => {
            dispatch((0, user_2.setAppUser)({ ...result.data, env: application_host_1.ENV_TYPE }));
            await cache_1.default.setItem(`appUser_${application_host_1.ENV_TYPE}`, result.data);
            dispatch((0, subscription_1.setUserQuota)({ uid: userId, ...(await loadUserQuota()) }));
            dispatch((0, appState_2.setShouldInsertUsername)(false));
            (0, rootNavigation_1.navigate)("Home", {
                screen: "Documents",
            });
            showNotification("Welcome", "Sucessfully logged in..", "success");
            trackUserSignUp();
        });
    }, [userId, email, trackUserSignUp]);
    const handleSavePress = (0, react_1.useCallback)(() => {
        setWasSavedAttempt(true);
        return handleSubmit(handleSaveUser)();
    }, [handleSaveUser]);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, { visible: shouldInsertUsername, transparent: true, animationType: shouldInsertUsername ? 'slide' : 'fade', children: (0, jsx_runtime_1.jsx)(react_native_1.KeyboardAvoidingView, { behavior: react_native_1.Platform.OS === "ios" ? "padding" : "height", style: [styles.background, isMobileScreen && { marginHorizontal: 16 }], children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.container, isMobileScreen && { maxWidth: '92%', alignContent: 'center' }], children: (0, jsx_runtime_1.jsxs)(react_native_1.Animated.View, { style: [
                        styles.content,
                        { transform: [{ translateY: moveAnimation }] }
                    ], children: [(0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: "white", fontSize: 24, fontWeight: 700, lineHeight: 29.05, children: "Choose a Username" }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.profileIconContainer, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser, color: '#A1A1A9', size: 32 }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.form, children: [(0, jsx_runtime_1.jsx)(FormInput, { control: control, name: 'Name', rules: { required: true }, onFocus: handleInputFocus, onBlur: handleInputBlur }), (0, jsx_runtime_1.jsx)(FormInput, { control: control, name: 'Username', rules: {
                                        required: true,
                                        validate: () => !isCheckingUsername && Boolean(isUniqueUserName),
                                        onChange: handleUsernameChange,
                                    }, onFocus: handleInputFocus, onBlur: handleInputBlur, InputRightElement: ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.spinner, children: [(0, jsx_runtime_1.jsx)(react_native_1.Animated.View, { style: {
                                                    transform: [{
                                                            rotateZ: rotationDegree,
                                                        }],
                                                }, children: isCheckingUsername && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSpinner, size: 16, color: colors_1.Colors.PRIMARY_300 })) }), isUniqueUserName && !isCheckingUsername && ((0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheck, size: 16, color: colors_1.Colors.SUCCESS }))] })) })] }), (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: 'Save', onPress: handleSavePress, customStyles: {
                                button: {
                                    height: 'auto',
                                },
                                text: {
                                    fontWeight: "500",
                                    paddingVertical: 16,
                                },
                            } })] }) }) }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    background: {
        backgroundColor: `${colors_1.Colors.DARK_700}CC`,
        flex: 1,
    },
    container: {
        backgroundColor: colors_1.Colors.DARK_600,
        maxWidth: 480,
        width: "100%",
        margin: 'auto',
        borderRadius: 32,
        overflow: 'hidden',
    },
    content: {
        alignItems: 'center',
        margin: 24,
    },
    profileIconContainer: {
        backgroundColor: '#323236',
        width: 72,
        height: 72,
        justifyContent: 'center',
        alignItems: 'center',
        marginVertical: 16,
        borderRadius: 72,
    },
    form: {
        width: '100%',
        gap: 24,
        marginBottom: 32,
    },
    spinner: {
        height: '100%',
        padding: 12,
    },
});
